export const DATA_STORE_IMG_PATH = "/static/img/data-store";

export const TESTIMONIALS = [
	{
		quote: {
			rawHtml:
				"We really enjoy working with ch-aviation. Their data reflects deep aviation expertise, and the team has been consistently responsive, helpful, and easy to work with.",
		},
		sourceName: "Matthias Hunger",
		sourcePositionAndCompany: "Managing Director, PaxUp",
		companyLogo: {
			altText: "PaxUp logo",
			link: "https://www.paxup.com/",
			url: `${DATA_STORE_IMG_PATH}/paxup-logo.png`,
		},
	},
	{
		quote: {
			rawHtml:
				"What sets the ch-aviation team apart is how deep their industry knowledge runs. They were also a genuinely responsive partner through the launch of our Risk Intelligence Platform in July 2026. Professional, quick to answer, and commercially switched on. Exactly what you want from a data partner.",
		},
		sourceName: "Ian Watkinson",
		sourcePositionAndCompany:
			"Chief Growth & Partnerships Officer, Insurwave",
		companyLogo: {
			altText: "Insurwave logo",
			link: "https://insurwave.com/",
			url: `${DATA_STORE_IMG_PATH}/insurwave-logo.svg`,
		},
	},
	{
		quote: {
			rawHtml:
				"We spent some time looking for good quality business aviation data but as soon as we came across the ch-aviation solutions, our search for the right partner quickly turned into an integration conversation. The team were flexible, responsive and understood our requirements meaning we were able to get to market quickly. A great team to work with!",
		},
		sourceName: "Peter Hind",
		sourcePositionAndCompany: "Chief Executive Officer, RDC Aviation",
		companyLogo: {
			altText: "RDC Aviation logo",
			link: "https://rdcaviation.com/",
			url: `${DATA_STORE_IMG_PATH}/rdc-logo.png`,
		},
	},
];

export const CATEGORIES = [
	{
		icon: "plane",
		name: "Aircraft",
		count: "10 feeds",
		body: "Commercial aviation aircraft and business jets, with technical specs, codes, fleet history, and current and past operators.",
	},
	{
		icon: "ops",
		name: "Operators",
		count: "10 feeds",
		body: "Airlines and business jet operators worldwide, including senior contacts, financial figures, passenger numbers, alliances, and start-ups.",
	},
	{
		icon: "pin",
		name: "Airports",
		count: "1 feed",
		body: "Airport profiles, codes, locations, and metadata for the airports of the world.",
	},
	{
		icon: "tag",
		name: "Ownership and valuations",
		count: "7 feeds",
		body: "Who owns each aircraft, what it's worth, lease rates, and ownership structures including SPVs and lessors.",
	},
	{
		icon: "act",
		name: "Flight activity",
		count: "10 feeds",
		body: "Where aircraft fly, how often, and how much, plus where they are right now. Based on ADS-B and other sources.",
	},
	{
		icon: "shield",
		name: "Safety",
		count: "1 feed",
		body: "Accidents and incidents by operator and aircraft.",
	},
	{
		icon: "wrench",
		name: "Maintenance",
		count: "2 feeds",
		body: "MRO providers, their customers, and tracked airframe maintenance events worldwide.",
	},
	{
		icon: "news",
		name: "News",
		count: "2 feeds",
		body: "Aviation news from ch-aviation with 80,000+ articles, tagged and filterable. A great fit for AI and LLM use cases like summarization, search, and alerting.",
	},
];

export const CUSTOMER_LOGOS = [
	{
		title: "Airbus",
		src: "/static/img/data-store/airbus-logo.svg",
		url: "https://www.airbus.com/en",
	},
	{
		title: "Boeing",
		src: "/static/img/data-store/boeing-logo.svg",
		url: "https://www.boeing.com/",
	},
	{
		title: "Amadeus",
		src: "/static/img/data-store/amadeus-logo.svg",
		url: "https://amadeus.com/en",
	},
	{
		title: "OAG",
		src: "/static/img/data-store/oag-logo.svg",
		url: "https://www.oag.com/",
	},
	{
		title: "RDC",
		src: "/static/img/data-store/rdc-logo.png",
		url: "https://rdcaviation.com/",
	},
	{
		title: "PaxUp",
		src: "/static/img/data-store/paxup-logo.png",
		url: "https://www.paxup.com/",
	},
];
